import dayjs from 'dayjs';

export default function(value) {
    /**
     * Formats time
     * Example: 1:13 => 01:13 AM
     * @param {String} value
     * @return {String}
     */
    if (!value) {
        return null;
    }
    let currentDate = dayjs(new Date()).format('MM/DD/YYYY');

    return value ? dayjs(currentDate + ' ' + value).format('hh:mm A') : '';
}
